<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" append-to-body :close-on-click-modal="false">
    <el-form :model="form" label-width="80px" :rules="rules" ref="ruleForm">
      <el-form-item label="分部名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="liaison">
        <el-input v-model="form.liaison"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <p style="color: red;margin-left: 100px;margin-top: -13px;margin-bottom: 10px;">注：手机号默认为系统账号</p>
      <el-form-item label="密码" prop="password">
        <el-input v-model="form.password" type="password" show-password></el-input>
      </el-form-item>
      <p style="color: red;margin-left: 100px;margin-top: -13px;margin-bottom: 10px;">注：密码最少6位由数字+字母组成</p>
      <el-form-item label="角色" prop="roleIds">
        <el-select v-model="form.roleIds" multiple placeholder="请选择" style="width: 100%">
          <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {addBranch,updateBranch} from '@/api/storeBranch.js'
import {getAllRole} from '@/api/companyManage.js'
export default {
  components: {},
  props: {},
  data() {
    return {
      dialogFormVisible: false,
      form: {
        id: '',
        name: '',
        liaison: '',
        phone: '',
        password: '',
        roleIds:[]
      },
      oldPhone:'',
      title: '新增分部',
      roleList:[],
      rules: {
        name: [
          { required: true, message: '请输入分部名称', trigger: 'blur' }
        ],
        phone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          { type: 'number',
            message: '手机号格式不正确',
            trigger: 'blur',
            transform(value) {
              var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
              if (!phonereg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            }
          }
        ],
        roleIds:[
            { required: true, message: '请选择角色', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.getRoles()
  },
  methods: {
    resetForm() {
      // this.$refs['ruleForm'].resetFields();
      this.form.id=''
      this.form.name=''
      this.form.liaison = ''
      this.form.phone=''
      this.form.password=''
      this.form.roleIds=[]
    },
    getRoles(){
      getAllRole().then(res=>{
        this.roleList = res.data
      })
    },
    edit(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.title = '编辑分部'
      this.oldPhone = row.phone
      this.dialogFormVisible = true
    },
    init() {
      this.resetForm()
      this.dialogFormVisible = true
    },
    save() {
      if (!this.form.roleIds || this.form.roleIds.length <= 0){
        this.$message.error('请选择角色');
        return
      }
      if ((this.form.id  && this.oldPhone != this.form.phone) || !this.form.id){
        if (this.form.password === '') {
          this.$message.error('请输入密码');
          return
        } else if (!/[a-zA-Z]/.test(this.form.password) || !/[0-9]/.test(this.form.password)) {
          this.$message.error('密码必须包含字母和数字');
          return
        } else if (this.form.password.length < 6) {
          this.$message.error('密码长度不能少于6位');
          return
        }
      }
      if (this.form.id){
        updateBranch(this.form).then(res => {
          this.$message.success('修改成功')
          this.dialogFormVisible = false
          this.$emit('getList')
        })
      }else {
        addBranch(this.form).then(res => {
          this.$message.success('保存成功')
          this.dialogFormVisible = false
          this.$emit('getList')
        })
      }
    }
  }

}
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.pageBox {
  display: flex;
  justify-content: flex-end;
}
</style>
